import React from 'react';
import {Link} from "react-router-dom";
import IconName from "../../svgLogo/SvgLogo";
import LoginPhoneNumber from "./LoginPhoneNumber";
import LoginSendCode from "./LoginSendCode";
import LoginPassword from "./LoginPassword";

const LoginPage = () => {
    return (
        <div className="login-page-wrapper d-flex justify-content-center align-items-center flex-column">
            <div className="logo-login-page">
                <Link to="/"><IconName name="sayman-logo" className="icon"/></Link>
            </div>
            <div className="login-box">
                <LoginPhoneNumber/>
                <LoginSendCode/>
                <LoginPassword/>
            </div>
        </div>
    );
};

export default LoginPage;
